/**
 * Resolve a select's current value when it's missing from the fetched options
 * (soft-deleted or otherwise excluded entity) so edit forms can still display
 * it instead of a blank field. The caller supplies its detail-endpoint hook,
 * which must tolerate deleted entities (and carry `deletedAt` on them).
 *
 * Single-select only — array values never resolve.
 */
export function useTombstoneEntity<T extends { _id: string }>(
  enabled: boolean,
  value: string | string[] | undefined,
  options: T[] | undefined,
  useDetail: (id: string) => { data: T | undefined }
): T | undefined {
  const id = enabled && typeof value === 'string' && value !== '' ? value : '';
  const missing = Boolean(options && id && !options.some((o) => o._id === id));
  const { data } = useDetail(missing ? id : '');
  // Gate on the current value so a stale cached resolution (value changed
  // since) never leaks into the trigger or options.
  return missing && data?._id === id ? data : undefined;
}
